
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class MoirePatternsEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time, width, height } = pc;
        const spacing = (20 + layerIndex * 10) / (config.parallaxPatternDensity || 1.0);
        const curTime = time * 0.1 * config.parallaxSpeed;
        const scale = config.parallaxScale || 1.0;

        ctx.strokeStyle = pc.color;
        ctx.lineWidth = 1 * scale;

        const drawGrid = (angle: number) => {
            ctx.save();
            ctx.rotate(angle);
            for (let x = -width * 2; x <= width * 2; x += spacing) {
                ctx.beginPath();
                ctx.moveTo(x, -height * 2);
                ctx.lineTo(x, height * 2);
                ctx.stroke();
            }
            ctx.restore();
        };

        const draw = () => {
            drawGrid(curTime);
            drawGrid(-curTime * 1.5);
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
